export const FETCH_COMMENTS = 'FETCH_COMMENTS';
export const RECEIVE_COMMENTS = 'RECEIVE_COMMENTS';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';

export function fetchComments({ parentId }) {
  return {
    type: FETCH_COMMENTS,
    parentId,
  };
}

export function receiveComments({ parentId, comments }) {
  return {
    type: RECEIVE_COMMENTS,
    parentId,
    comments,
  };
}

export function createComment(commentData) {
  return {
    type: CREATE_COMMENT,
    commentData,
  };
}

export function deleteComment({ commentId, parentId }) {
  return {
    type: DELETE_COMMENT,
    commentId,
    parentId,
  };
}
